import { fps, lps, playerState, pps } from "@stores";
import { Backdrop, Text, VersionInfo } from "@gui/components";
import { PlayerConfig } from "@objects/entities";
const InformationOverlay = () => {
    const DECIMAL_POINT = 100;
    /**
     * Generate a coordinate text in the format `<x|y|z>: <value>`.
     * Truncate the value based on the decimalPoint constant.
     * @param coordinatePart either "x", "y" or "z"
     * @returns the generated string.
     */
    const formatCoordinate = (coordinatePart) => {
        const state = playerState();
        if (state === undefined)
            return "";
        return `${coordinatePart.toUpperCase()}: ${Math.trunc(state.position[coordinatePart] * DECIMAL_POINT) / DECIMAL_POINT}`;
    };
    return (<Backdrop>
            <VersionInfo />
            <Text>FPS: {fps()}</Text>
            <Text>
                Logic updates per second: {lps()} | Physics updates per second: {pps()}
            </Text>
            <Text>
                Position: {formatCoordinate("x")} | {formatCoordinate("y")} |{" "}
                {formatCoordinate("z")}
            </Text>
            <Text>
                Health: {Math.trunc(playerState()?.health || 0)} / {PlayerConfig.MAX_HEALTH}
            </Text>
        </Backdrop>);
};
export default InformationOverlay;
